module.exports = __webpack_public_path__ + "img/mendianquanpan.7872c23e.png";